import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { getAllCustomerDetail } from "../../common/searchModal/api";
import OutStandingReportCart from "../employeePayRoll/outStandingReportCart";
import CardCounterInformation from "./card";
import SearchIcon from "@mui/icons-material/Search";
import SearchModalCustomer from "../../common/searchModal/customer";
import { getData } from "./counterInformationApi";
import { CustomeDetail } from "../customerDetail/customerDetail";
import LastCustomer from "../../common/searchModal/lastCustomer";
import DynamicBreadcrumbs from "../../common/Breadcrumb";
import DownloadIcon from "@mui/icons-material/Download";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import dayjs from "dayjs";
import { useNavigate } from "react-router";
import Heading from "../../common/Heading";

const CustomerInfo = ({ report }) => {
  const [collection, setCollection] = useState([]);
  const [search, setSearch] = useState("");
  const [searchOutStandingsModal, setSearchOutStandingsModal] = useState(false);

  const [openT, setOpenT] = useState(false);
  const [selectedData, setSeletecData] = useState(null);
  const [value, setValue] = useState("all");
 const navigate = useNavigate();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // const groupByDate = (data) => {
  //   return data.reduce((acc, bill) => {
  //     const date = dayjs(bill.billDate).format("DD/MM/YYYY");
  //     if (!acc[date]) {
  //       acc[date] = [];
  //     }
  //     bill.purchaseDetails.forEach((detail) => {
  //       acc[date].push({
  //         service: detail.itemDescription,
  //         employee: detail.attendedBy,
  //         amount: detail.amount,
  //         billDate: bill.billDate,
  //       });
  //     });
  //     return acc;
  //   }, {});
  // };

  useEffect(() => {}, []);
  return (
    <Box
      sx={{
        // p: "17px 20px",
        py: "17px",
        px: { xs: "10px", sm: "20px", md: "30px" },
        background: "#ede9ff",
        minHeight: "100vh",
      }}
    >
      <Grid container alignItems="center" spacing={2}>
        {/* {!report && <DynamicBreadcrumbs />} */}
        <Heading
          name={report ? "Customer History Report" : "Customer History"}
        />

        {/* <Grid item xs={12} sx={{}}>
          <Box
            sx={{
              background:
                "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
              padding: "10px",
              paddingLeft: "20px",
              borderRadius: 2,
              color: "#01008B", // optional text color
              textAlign: "left",
            }}
          >
            <Typography
              variant="h6"
              fontSize={{ xs: "12px", sm: "13px", md: "15px" }}
            >
              {report ? "Customer History Report" : "Customer History"}
            </Typography>
          </Box>
        </Grid> */}

        {/* <Grid item xs={12} sm={report ? 10 : 12}>
          <Box
            readonly
            fullWidth
            onClick={() => {
              // setSearchOutStandingsModal(true)
            }}
            sx={{
              display: "flex",
              height: "23px",
              justifyContent: "space-between",
              // width: "70%",
              border: "1px solid #c9c9c9",
              p: 1,
              borderRadius: "4px ",
              backgroundColor: "white",
              color: "grey",
              '&:hover': {
                cursor: 'pointer !important',
              },
            }}
            onChange={(e) => {
            }}

          >
            <Typography variant="p" >
              {selectedData?.name !== "" ? selectedData?.name : "Search by Name/Mobile Number"}
            </Typography>
            <SearchIcon
              onClick={() => {
                setOpenT(true)

              }}
              sx={{
                color: (theme) => theme.palette.primary.main,
                cursor: "pointer",
              }}
            />
          </Box>
        </Grid> */}

        <Grid item xs={12} sm={12} md={10}>
          {/* <FormControl sx={{ width: "100%", position: "relative", height: "50px" }}>
            <InputLabel
              id="demo-simple-select-label"
              sx={{ position: "absolute", top: "0", height: "50px" }}
            >
              Category
            </InputLabel> */}
          <TextField
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={
              selectedData?.name
                ? `${selectedData.name} - ${selectedData.customerMobile || ""}`
                : ""
            }
            fullWidth
            size="small"
            InputLabelProps={{
              shrink: selectedData?.name ? true : false,
              sx: {
                color: "#545454",
                fontWeight: 400,
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
                paddingX: "7px",
              },
            }}
            InputProps={{
              endAdornment: (
                <SearchIcon
                  sx={{
                    color: (theme) => theme.palette.primary.main,
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setOpenT(true);
                  }}
                />
              ),
            }}
            sx={{
              backgroundColor: "white",
              display: "flex",
              fontSize: { xs: "12px", sm: "13px", md: "15px" },

              alignItems: "center",
              borderRadius: "4px",
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  border: "none",
                },
              },
            }}
            // size="small"
            label="Search Customer"
            onChange={(e) => {
              // setFilterBy(e.target.value);
              // getexpence(
              //   {
              //     fromDate: startDateFormat,
              //     toDate: endDate,
              //     search: e.target.value,
              //     page: 1,
              //     pageSize: pagination.pageSize,
              //   },
              //   GetDetailsExpense,
              //   setNumberOfRecords,
              //   setexpence,
              //   setTotalAmount
              // );
            }}
          >
            {/* {listChategory.map((item, index) => {
                return (
                  <MenuItem value={item.name} key={"option" + index}>
                    {item.name}
                  </MenuItem>
                );
              })} */}
          </TextField>
          {/* </FormControl> */}
        </Grid>

        {/* Download Button */}
        {report && (
          <Grid
            item
            md={2}
            xs={12}
            sx={{
              padding: "0px",
            }}
          >
            <Button
              variant="contained"
              fullWidth
              sx={{
                height: "40px",
                backgroundColor: "#14008B",
                padding: "0px",
              }}
              endIcon={<DownloadIcon />}
            >
              Download
            </Button>
          </Grid>
        )}

        {/* <Grid xs={12}>

          {
            collection.map((item, index) => {
              return (
                <CardCounterInformation
                  item={item}
                />
              )
            })
          }
        </Grid> */}

        <Grid item xs={12}>
          <Box
            sx={{
              // p: "20px 10px",
              py: "20px",
              px: { xs: "10px", sm: "10px", md: "50px" },
              background: "#fff",
              borderRadius: "12px",
              fontFamily: "'Montserrat', sans-serif",
            }}
          >
            <Grid container spacing={{ xs: 0, sm: 0, md: 1 }}>
              <Grid
                container
                spacing={1}
                sx={{
                  borderBottom: "1px solid #1E1E1E",
                  padding: { lg: "10px", xs: "0px", sm: "0px" },
                  paddingRight: { lg: "30px", xs: "0px" },
                  sm: "0px",
                }}
              >
                <Grid item xs={3}>
                  <Typography
                    fontWeight={500}
                    align="center"
                    color="primary"
                    sx={{
                      fontSize: { xs: "10px", sm: "13px", md: "15px" },
                    }}
                  >
                    {/* {report ? "Services" : "Date"} */}
                    Date
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography
                    fontWeight={500}
                    color="primary"
                    sx={{
                      whiteSpace: "normal",
                      fontSize: { xs: "10px", sm: "13px", md: "15px" },
                    }}
                  >
                    Service/Product
                    {/* {report ? "Employee Name" : "Service/Product"} */}
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography
                    fontWeight={500}
                    align="center"
                    color="primary"
                    sx={{
                      fontSize: { xs: "10px", sm: "13px", md: "15px" },
                    }}
                  >
                    Employee Name
                    {/* {report ? "Date" : "Employee Name"} */}
                  </Typography>
                </Grid>

                <Grid item xs={3}>
                  <Typography
                    fontWeight={500}
                    align="center"
                    color="primary"
                    sx={{
                      fontSize: { xs: "10px", sm: "13px", md: "15px" },
                    }}
                  >
                    Amount
                  </Typography>
                </Grid>
              </Grid>

              {/* Header */}
              <Grid
                container
                mt={2}
                sx={{
                  height: "50vh",
                  overflowY: "auto",
                  marginTop: "10px",
                  paddingRight: "10px",
                }}
              >
                {/* Data Rows */}
                <Grid item xs={12}>
                  {/* Data Rows */}
                  {Object.entries(
                    collection.reduce((acc, bill) => {
                      const date = dayjs(bill.billDate).format("DD/MM/YYYY");
                      if (!acc[date]) acc[date] = {};
                      bill.purchaseDetails?.forEach((detail) => {
                        if (!acc[date][detail.itemDescription]) {
                          acc[date][detail.itemDescription] = [];
                        }
                        acc[date][detail.itemDescription].push({
                          service: detail.itemDescription,
                          employee: detail.attendedBy,
                          amount: detail.amount,
                          billDate: bill.billDate,
                        });
                      });
                      return acc;
                    }, {}),
                  ).map(([date, services], idx) => (
                    <Box
                      key={idx}
                      sx={{
                        mb: 2,
                        borderRadius: "10px",
                        background: "#E3E3FF",
                      }}
                    >
                      {/* Data rows */}
                      {Object.entries(services).map(([service, rows], i) => (
                        <Grid
                          container
                          key={i}
                          sx={{
                            borderBottom:
                              i !== Object.keys(services).length - 1
                                ? "1px solid #ccc"
                                : "none",
                            p: 1,
                          }}
                        >
                          <Grid item xs={3}>
                            {i === 0 ? (
                              <Typography
                                align="center"
                                fontWeight="500"
                                sx={{
                                  fontSize: {
                                    xs: "12px",
                                    sm: "13px",
                                    md: "15px",
                                  },
                                }}
                              >
                                {date}
                              </Typography>
                            ) : (
                              <Typography align="center"> </Typography>
                            )}
                          </Grid>

                          <Grid item xs={3}>
                            <Typography
                              fontWeight="600"
                              sx={{
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                              }}
                            >
                              {service}
                            </Typography>
                          </Grid>

                          <Grid item xs={3}>
                            {rows.map((r, j) => (
                              <Typography
                                key={j}
                                fontWeight="500"
                                sx={{
                                  pl: { xs: 2, sm: 3, md: 4, lg: 9 },
                                  mb: 0.5,
                                  fontSize: {
                                    xs: "12px",
                                    sm: "13px",
                                    md: "15px",
                                  },
                                }}
                              >
                                {r.employee}
                              </Typography>
                            ))}
                          </Grid>

                          <Grid item xs={3} pl={{ xs: 3, sm: 4 }}>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                              }}
                            >
                              <Box
                                sx={{
                                  fontSize: {
                                    xs: "12px",
                                    sm: "13px",
                                    md: "15px",
                                  },
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <CurrencyRupeeIcon
                                  sx={{ fontSize: "inherit" }}
                                />
                              </Box>

                              <Typography
                                fontWeight="500"
                                sx={{
                                  fontSize: {
                                    xs: "12px",
                                    sm: "13px",
                                    md: "15px",
                                  },
                                }}
                              >
                                {rows[0]?.amount?.toFixed(2) ?? "-"}
                              </Typography>
                            </Box>
                          </Grid>
                        </Grid>
                      ))}

                      {/* Total Row */}
                      <Grid
                        container
                        sx={{
                          p: 1,
                          background: "#d9d9ff",
                          borderTop: "2px solid #999",
                        }}
                      >
                        <Grid item xs={9}>
                          <Typography
                            fontWeight="600"
                            align="right"
                            sx={{
                              fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            }}
                          >
                            Total
                          </Typography>
                        </Grid>
                        <Grid item xs={3} pl={{ xs: 2, sm: 3 }}>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <Box
                              sx={{
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <CurrencyRupeeIcon sx={{ fontSize: "inherit" }} />
                            </Box>
                            <Typography
                              fontWeight="600"
                              sx={{
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                              }}
                            >
                              {Object.values(services)
                                .flat()
                                .reduce((sum, r) => sum + (r.amount || 0), 0)
                                .toFixed(2)}
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Grid>

        <LastCustomer
          searchModal={openT}
          setSearchModal={setOpenT}
          callback={(data) => {
            console.log("Data", data);
            getData({ mobile: data?.customerMobile }, (data) => {
              console.log("data detail ", data?.data);
              setCollection(data?.data);
            });

            setSeletecData(data);
            setOpenT(false);
          }}
        />
      </Grid>
    </Box>
  );
};

export default CustomerInfo;
